import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { useTranslation } from 'react-i18next';
import LogoComponent from "../components/logo-comp";
import PartnersBanner from '../components/partners-banner';
import PageBackground from '../components/background-component';

const JoinUsPage = () => {
    const { t } = useTranslation();
    const bArr = [
        {imgUrl: "/img/partner-logos/giardini.png", imgWidth: "149px"},
        {imgUrl: "/img/partner-logos/nobilis.png", imgWidth: "150px"},
        {imgUrl: "/img/partner-logos/alcantara.png", imgWidth: "155px"},
        {imgUrl: "/img/partner-logos/studioart.png", imgWidth: "149px"},
        {imgUrl: "/img/partner-logos/inter.png", imgWidth: "152px"},
        {imgUrl: "/img/partner-logos/loro.png", imgWidth: "141px"},
        {imgUrl: "/img/partner-logos/misia.png", imgWidth: "108px"},
        {imgUrl: "/img/partner-logos/fischbacher.png", imgWidth: "153px"},
        {imgUrl: "/img/partner-logos/gandiablasco.png", imgWidth: "155px"},
        {imgUrl: "/img/partner-logos/aldeco.png", imgWidth: "87px"}
    ];
    return (
        <div className="pg-form pg-join page-bg">
            <div className="page-wrapper">
                <PageBackground
                    desktop={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-join.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-join.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-join.jpg`
                    }}
                    mobile={{
                    avif: `${process.env.PUBLIC_URL}/img/page-bg-join.avif`,
                    webp: `${process.env.PUBLIC_URL}/img/page-bg-join.webp`,
                    jpg: `${process.env.PUBLIC_URL}/img/page-bg-join.jpg`
                    }}
                />
                <Row className="mb-3">
                    {/* <Col md="6" className="margin-0 form-bg-out">
                        <div className="form-bg"></div>
                    </Col> */}
                    <Col md="12" className="margin-0">
                        <div className='bl-form bl-form-bg join-form'>
                            <LogoComponent logoColor="white" />
                            <h1>Material Hub</h1>
                            <a href="/login" className='btn'>Join Now</a>
                            <div>
                                <PartnersBanner banners={bArr} columns="1fr 1fr 1fr 1fr 1fr" />
                            </div>
                            <div className='form-footer'>
                                <p>by Kate International</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default JoinUsPage;